<template>
  <el-dialog title="新增用户" :visible.sync="visible" width="500px" :before-close="closeDialog">
    <el-form v-if="user" ref="form" :model="user" :rules="rules" style="width:400px" label-width="100px">

      <el-form-item label="用户名" prop="username">
        <el-input v-model="user.username"></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="user.name"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="user.password"></el-input>
      </el-form-item>
      <el-form-item align="center">
        <el-button @click="$refs.form.resetFields()">重 置</el-button>
        <el-button @click="submit" type="primary">提 交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { rules } from "@/utils";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      user: {
        username: "",
        password: "123456"
      },
      rules: {
        username: [
          rules.required(),
          {
            validator: async (rule, value, cb) => {
              let res = await this.$request(
                this.$api.user.exist({ username: value })
              );
              if (res) {
                throw new Error("用户名已存在");
              }
            },
            trigger: "blur"
          }
        ],
        password: [rules.required()]
      }
    };
  },
  methods: {
    ...mapActions("user", ["add"]),
    async submit() {
      let ok = await this.$refs.form.validate();
      if (!ok) {
        return;
      }
      let res = await this.add(this.user);
      this.$message.success("新增用户成功");
      this.closeDialog();
    },
    closeDialog(){
      this.$emit('update:visible', false);
      this.$refs.form.resetFields();
    }
  }
};
</script>

<style>
</style>

